import { z } from "zod";

export const sdgTargetSchema = z.object({
  id: z.number(),
  target: z.string(),
});

export type SdgTarget = z.infer<typeof sdgTargetSchema>;
